import PMBSelect from 'components/PMBSelect'
import { capitalizeEveryWord } from 'helpers'
import {
  AlertCircle,
  ChevronDown,
  ChevronRight,
  Lock,
  Unlock,
} from 'react-feather'
import { useSelector } from 'react-redux'
import { Card, CardText, Input, InputGroup, InputGroupText } from 'reactstrap'
import InventoryCodeInput from '../Input/InventoryCodeInput'

export default function SplitStockCard({
  item,
  index,
  onShowItem,
  setIndexSelectedSplitStock,
  onChangeValue,
  selectedStock,
  disabledDropdown = true,
  isProcessAction = false,
  customStyleList,
  onLockValue,
}) {
  const handleInventoryCodeChange = (code, index) => {
    onChangeValue('ownerCode', code, index)
  }

  const { data } = useSelector((state) => state.publicVersion)

  return (
    <Card className="small-padding border-0 shadow-sm">
      <CardText className="fw-semibold no-padding">Bagian {index + 1}</CardText>

      <div className="mt-2">
        <CardText className="no-padding">Kode inventori (opsional)</CardText>
        <InventoryCodeInput
          value={item?.ownerCode || ''}
          onChange={(text) => handleInventoryCodeChange(text, index)}
          isAutoFocus={true}
          customStyleList={customStyleList}
        />
      </div>

      <div className="bordered mt-2 d-flex justify-content-between align-items-center">
        <Input
          style={{ borderColor: 'white', caretColor: 'transparent' }}
          className="border-input button"
          placeholder="Pilih barang"
          disabled={disabledDropdown}
          onClick={() => {
            if (disabledDropdown) {
              return
            } else {
              setIndexSelectedSplitStock(index)
              onShowItem('item', true)
            }
          }}
          value={selectedStock?.item?.nameItem}
        />
        {!disabledDropdown ? (
          <ChevronRight color="#667085" style={{ paddingRight: 10 }} />
        ) : null}
      </div>
      <div className="d-flex justify-content-between">
        <div className="mt-2" style={{ width: '49%' }}>
          <div
            className={`${!item?.amount || item?.amount < 0 ? 'bordered-warning' : 'bordered'} d-flex justify-content-between align-items-center`}
          >
            <InputGroup>
              <Input
                value={item?.amount}
                placeholder="Jumlah"
                style={{ borderColor: 'white' }}
                onChange={(text) =>
                  onChangeValue('amount', text.target.value, index)
                }
              />
              {!item?.amount || item?.amount < 0 ? (
                <InputGroupText
                  style={{ backgroundColor: 'white', borderColor: 'white' }}
                >
                  <AlertCircle size={14} color="#F04438" />
                </InputGroupText>
              ) : null}
            </InputGroup>
            {onLockValue ? (
              <div
                className="pr-2 mb-1"
                style={{ cursor: 'pointer' }}
                onClick={onLockValue}
              >
                {item?.locked ? <Lock size={20} /> : <Unlock size={20} />}
              </div>
            ) : null}
          </div>
          {!item?.amount || item?.amount < 0 ? (
            <div className="mt-2">
              <CardText style={{ color: '#F04438', fontSize: 14 }}>
                Tidak boleh kosong saat memisah
              </CardText>
            </div>
          ) : null}
        </div>
        <div className="mt-2" style={{ width: '49%' }}>
          {isProcessAction ? (
            <>
              <PMBSelect
                options={data?.unitArray ?? []}
                isMulti={false}
                value={[
                  {
                    value: capitalizeEveryWord(item?.unit),
                    label: capitalizeEveryWord(item?.unit),
                  },
                ]}
                onChange={(selectedUnit) =>
                  onChangeValue(
                    'unit',
                    selectedUnit?.value?.toLowerCase(),
                    index,
                  )
                }
                placeholder="Pilih Satuan"
                menuPosition="fixed"
                menuPlacement="bottom"
                menuPortalTarget={
                  typeof window !== 'undefined' ? document.body : null
                }
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderColor: '#d1d5db',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#d1d5db',
                    },
                    borderRadius: '8px',
                    padding: '2px',
                    minWidth: '100%',
                    maxWidth: '100%',
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: '#e0f2ff',
                    borderRadius: '12px',
                    padding: '2px 6px',
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: '#0369a1',
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: '#0369a1',
                    '&:hover': {
                      backgroundColor: '#b3e5fc',
                      color: '#005f8e',
                    },
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    color: '#6b7280',
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    color: '#6b7280',
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    maxHeight: 120,
                    overflowY: 'auto',
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </>
          ) : (
            <div className="bordered d-flex justify-content-between align-items-center disabled">
              <Input
                style={{ borderColor: '#e9ecef', caretColor: 'transparent' }}
                className="border-input button"
                placeholder="Kg"
                value={item?.unit}
                disabled
              />
              <ChevronDown color="#667085" style={{ paddingRight: 10 }} />
            </div>
          )}
        </div>
      </div>

      <div className="mt-2">
        <CardText className="no-padding">Bundle (opsional)</CardText>
        <div className="bordered mt-2 d-flex justify-content-between align-items-center">
          <Input
            value={item?.bundle ?? ''}
            placeholder="Masukkan jumlah bundle"
            style={{ borderColor: 'white' }}
            onChange={(e) => {
              const val = e.target.value?.replace(/[^\d]/g, '')
              onChangeValue('bundle', val ? Number(val) : '', index)
            }}
          />
        </div>
      </div>
    </Card>
  )
}
